import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignInComponent } from './sign-in/sign-in.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { PrivateComponent } from './private/private.component';
import { CheckUserComponent } from './check-user/check-user.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { AutoSignInComponent } from './auto-sign-in/auto-sign-in.component';

import { IsAuthenticated, IsNotAuthenticated, CheckUserIsAuthenticated } from './auth.guard';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent, canActivate: [IsNotAuthenticated] },
  { path: 'auto-sign-in', component: AutoSignInComponent, canActivate: [IsNotAuthenticated] },
  { path: 'sign-out', component: SignOutComponent, canActivate: [IsAuthenticated] },
  { path: 'private', component: PrivateComponent, canActivate: [IsAuthenticated] },
  { path: 'check-user', component: CheckUserComponent, canActivate: [CheckUserIsAuthenticated] },
  { path: '', redirectTo: '/private', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
